<app-button-advanced
  class="reset-transparency-action"
  [action]="resetAction"
  [hotButton]="'T'"
  matTooltip="{{ 'viewer.Tools.ResetTransparency' | translate }}"
  [matTooltipPosition]="'left'"
  [matTooltipDisabled]="isDisabled$ | async"
>
</app-button-advanced>
